import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Componente SEO riutilizzabile. Imposta title, description, OG, canonical e JSON-LD.
 */
const Seo = ({ title, description, canonical, jsonld, image, noindex }) => {
  const fullTitle = title || "quandomiserve.it — Cerca, Confronta, Noleggia Piattaforme Aeree";
  const fullDesc = description || "Cerca, confronta e noleggia piattaforme aeree in tutta Italia. Autocarrate, ragni, verticali e molto altro.";
  const ogImage = image || "https://www.quandomiserve.it/og-cover.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      {noindex && <meta name="robots" content="noindex, nofollow, noarchive" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonld && (
        <script type="application/ld+json">
          {JSON.stringify(jsonld)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
